import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { SkuBulkUploadDataService } from "../../services/sku-bulk-upload.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CatExpertRouterLink } from "../../app-routing-enum";

export type NavigationItem = "Home" | "Data" | "Review";

@Component({
  selector: "remediation-navigation",
  templateUrl: "./remediation-navigation.component.html",
  styleUrls: ["./remediation-navigation.component.scss"],
})
export class RemediationNavigationComponent implements OnInit {
  @Input() selectedItem: NavigationItem = "Review";
  @Output() navigationChange = new EventEmitter<NavigationItem>();
  @Output() saveIconClicked = new EventEmitter<void>();

  keyAccountName: string = "";
  fileName: string = "";
  localBulkUploadData: any = {};

  constructor(
    private skuBulkUploadDataService: SkuBulkUploadDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.navigationChange.emit(this.selectedItem);
    const rawStoredData = sessionStorage.getItem("skuBulkUploadData");
    this.localBulkUploadData = rawStoredData ? JSON.parse(rawStoredData) : null;
    const fileObject: any = this.skuBulkUploadDataService.getFileName();
    this.fileName =
      fileObject?.fileName || this.localBulkUploadData["fileName"] || "";
    this.keyAccountName =
      fileObject?.selectedKeyAccountObject?.name ||
      this.localBulkUploadData["selectedKeyAccountObject"]["name"];
  }

  onSelect(item: NavigationItem): void {
    this.selectedItem = item;
    this.navigationChange.emit(item);
  }

  isActive(item: NavigationItem): boolean {
    return this.selectedItem === item;
  }

  onSave() {
    this.saveIconClicked.emit();
  }

  onBack() {
    this.router.navigate([
      `${CatExpertRouterLink.Studio}/${CatExpertRouterLink.Libraries}/${CatExpertRouterLink.ProductLibrary}/${CatExpertRouterLink.BulkUpload}`,
    ]);
  }
}
